import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    AttachmentGridDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getCornerStyle
} from "../../../../helpers/theme/corner";

export const ATTACHMENT_GRID_ASPECT_RATIOS: Record<number, number> = {
    1: 4 / 3,
    2: 2,
    3: 1,
    4: 1
};

export const ATTACHMENT_GRID_MAX_TILES = 4;

const stylesheet = StyleSheet.create({
    column: {
        flexDirection: "column",
        flexShrink: 1,
        flexGrow: 1
    },
    row: {
        flexDirection: "row",
        flexShrink: 1,
        flexGrow: 1
    },
    container: {
        overflow: "hidden",
        maxWidth: "100%"
    }
});

export const useStyles = ({
    shapeConfigs,
    radiuses,
    borders,
    count
}: AttachmentGridDynamicStyleType) => {
    const styles = {
        container: {
            aspectRatio: ATTACHMENT_GRID_ASPECT_RATIOS[Math.min(count, ATTACHMENT_GRID_MAX_TILES)],
            width: shapeConfigs.cardWidth,
            ...getCornerStyle({
                radius: radiuses.surface,
                shapeConfigs
            }),
            gap: borders.subtract
        } as Mutable<ViewStyle>,
        gap: {
            gap: borders.subtract
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
